import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider } from './Context';
import Main from './Main';

export default function Index({ enterpriseId, policyEnabled }) {
  return (
    <StrictMode>
      <UsersContextProvider>
        <ContextProvider enterpriseId={enterpriseId} policyEnabled={policyEnabled}>
          <Main />
        </ContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  policyEnabled: PropTypes.bool.isRequired,
};
